import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck } from "@phosphor-icons/react";
import api, { formatError } from "@/lib/api";
import { Modal } from "@/components/Modal";
import { Button } from "@/components/ui/button";
import { inr } from "@/pages/Customers";

export function PendingReview({ onDone }) {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [sel, setSel] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/ledger/pending").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  if (!rows.length) return null;
  const act = async (status) => {
    setBusy(true);
    try {
      const r = await api.post("/ledger/bulk-verify", { entry_ids: sel, status });
      toast.success(`${r.data.updated} entr${r.data.updated === 1 ? "y" : "ies"} ${status.toLowerCase()}`); setSel([]); setOpen(false); load(); onDone();
    } catch (e) { toast.error(formatError(e)); } finally { setBusy(false); }
  };
  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  return (
    <>
      <button onClick={() => setOpen(true)} className="w-full mb-4 rounded-2xl border border-amber-200 bg-amber-50 p-4 text-left text-sm text-amber-900 flex items-center gap-2" data-testid="pending-review-banner">
        <ShieldCheck size={18} />{rows.length} entr{rows.length === 1 ? "y is" : "ies are"} awaiting Super Admin review. Review now →
      </button>
      {open && (
        <Modal open onOpenChange={setOpen} title="Review pending payments" testid="pending-review-modal">
          <p className="text-xs text-muted-foreground">These entries were recorded before automatic verification or came from a payment gateway without a confirmed success. Check each one before verifying.</p>
          <div className="max-h-[50vh] overflow-y-auto divide-y">
            {rows.map((r) => (
              <label key={r.id} className="flex gap-3 py-2 text-sm items-start" data-testid={`pending-row-${r.id}`}>
                <input type="checkbox" checked={sel.includes(r.id)} onChange={() => toggle(r.id)} className="mt-1" data-testid={`pending-check-${r.id}`} />
                <span className="flex-1"><Link to={`/customers/${r.customer_id}`} className="font-semibold hover:text-primary">{r.customer_name}</Link> · {inr(r.amount)} · {String(r.date).slice(0, 10)} · {r.method || "—"}{r.transaction_ref ? ` · ${r.transaction_ref}` : ""}
                  <span className="block text-xs text-muted-foreground">{r.origin}</span></span>
              </label>))}
          </div>
          <div className="flex flex-wrap gap-2">
            <Button variant="outline" size="sm" onClick={() => setSel(sel.length === rows.length ? [] : rows.map((r) => r.id))} data-testid="pending-select-all">{sel.length === rows.length ? "Clear" : "Select all"}</Button>
            <Button size="sm" disabled={!sel.length || busy} onClick={() => act("Verified")} className="bg-gold text-black font-semibold" data-testid="pending-verify-btn">Verify selected ({sel.length})</Button>
            <Button size="sm" variant="outline" disabled={!sel.length || busy} onClick={() => act("Rejected")} data-testid="pending-reject-btn">Reject selected</Button>
          </div>
        </Modal>)}
    </>
  );
}
